import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Image as ImageIcon } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { t, SERVICES } from "../lib/i18n";
import ServiceIcon from "../components/ServiceIcon";
import { api, API } from "../lib/api";

const ServicesPage = () => {
  const { tr } = useLang();
  const [dbServices, setDbServices] = useState(null);

  useEffect(() => {
    api.get("/services/public").then((r) => setDbServices(r.data || [])).catch(() => setDbServices([]));
  }, []);

  const dbList = (dbServices || []).map((s) => ({
    key: s.key,
    photo: s.photo_file ? `${API}/services/${s.key}/photo` : null,
    icon: s.icon || "FileText",
    en: { title: s.name_en, desc: s.desc_en },
    hi: { title: s.name_hi, desc: s.desc_hi },
    fee: s.fee,
  }));

  const list = dbList.length > 0 ? dbList : SERVICES;

  return (
    <div data-testid="services-page" className="max-w-7xl mx-auto px-4 lg:px-8 py-14 lg:py-16">
      <div className="max-w-3xl">
        <div className="text-xs uppercase tracking-[0.14em] text-teal-700 font-semibold">{tr(t.nav.services)}</div>
        <h1 className="mt-2 text-4xl sm:text-5xl font-heading font-semibold text-slate-900 tracking-tight">
          {tr({ en: "Everything we help you file", hi: "हम आपकी हर फाइलिंग में सहायक हैं" })}
        </h1>
        <p className="mt-4 text-base text-slate-600 leading-relaxed">
          {tr({ en: "Tap a service to open a request form. Upload documents right from your phone — we handle the rest.", hi: "फॉर्म खोलने के लिए किसी सेवा पर टैप करें। दस्तावेज़ सीधे मोबाइल से अपलोड करें — बाकी हम संभालेंगे।" })}
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {list.map((s) => (
          <Link key={s.key} to={`/submit?service=${s.key}`} className="group flex flex-col rounded-lg border border-slate-200 bg-white overflow-hidden hover:-translate-y-1 hover:shadow-md transition-transform" data-testid={`service-card-${s.key}`}>
            <div className="h-36 bg-slate-100">
              {s.photo ? (
                <img src={s.photo} alt={s.en.title} className="w-full h-full object-cover" />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-teal-400"><ServiceIcon name={s.icon} className="w-9 h-9" /></div>
              )}
            </div>
            <div className="flex-1 p-5">
              <h3 className="font-heading font-semibold text-slate-900 text-base">{tr({ en: s.en.title, hi: s.hi.title })}</h3>
              <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{tr({ en: s.en.desc, hi: s.hi.desc })}</p>
              {s.fee && <div className="mt-3 text-sm font-medium text-teal-700">{s.fee}</div>}
              <div className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-teal-700">
                {tr(t.common.apply)} <ArrowRight className="w-3.5 h-3.5" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ServicesPage;
